import classNames from "classnames";
import classes from "./MarketingCloudProfileCenterIframe.module.less";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";

interface Props {
  className?: string;
  url: string;
}

export const MarketingCloudProfileCenterIframe = ({ url, className }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  return (
    <div className={classNames(classes.root, className)}>
      <p className={classNames(classes.title, loading && classes.loading)}>{t("myAccount.mcProfileCenter.title")}</p>
      <iframe
        src={url}
        className={classNames(classes.iframe, loading && classes.loading)}
        onLoad={() => setLoading(false)}
      />
      {loading && <CircleSpinner className={classes.spinner} />}
    </div>
  );
};
